var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoftPowerPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D04423"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19h6v1h-6v-1zm0 2h6v1h-6v-1zm1-6h3a2.942 2.942 0 01-.883 2.125 3.01 3.01 0 01-.953.64A2.923 2.923 0 0117 18a3.06 3.06 0 01-1-.172v-5.656A3.06 3.06 0 0117 12v3zm-5.43-.133c.26 0 .474.057.64.172.173.11.259.307.259.594 0 .292-.084.497-.25.617-.162.115-.378.172-.649.172h-.445v-1.555h.445zM24 12.602V24H11v-2.625l-3-.477V12l3-.43V8h8.398L24 12.602zm-12.336 4.671c.255 0 .503-.033.742-.101.245-.068.459-.17.64-.305a1.563 1.563 0 00.61-1.273c0-.297-.05-.547-.148-.75a1.263 1.263 0 00-.39-.492 1.549 1.549 0 00-.602-.266 3.087 3.087 0 00-.75-.086H10v5h1.125v-1.727h.54zM23 14h-5V9h-6v2.43l3-.43v11l-3-.469V23h11v-9zm0-1l-4-4v4h4z",
    fill: "#fff"
  })));
}

export default SvgMicrosoftPowerPoint;